import { EmailIntakeQueueRepository } from "../repositories/EmailIntakeQueueRepository";
import { EmailIntakeQueueOperationResult } from "../entities/EmailIntakeQueueEntity";

/**
 * Update Email Status Use Case
 * Updates status for one or multiple emails
 */
export class UpdateEmailStatusUseCase {
  constructor(private repository: EmailIntakeQueueRepository) {}

  async execute(
    ids: number[],
    status: "ignore" | "pushed"
  ): Promise<EmailIntakeQueueOperationResult> {
    // Validate ids array
    if (!ids || ids.length === 0) {
      throw new Error("At least one email ID is required");
    }

    // Validate status
    if (!["ignore", "pushed"].includes(status)) {
      throw new Error('Invalid status. Must be "ignore" or "pushed"');
    }

    // Validate all IDs are positive integers
    for (const id of ids) {
      // Handle string numbers that might come from JSON parsing
      const numId = typeof id === "string" ? parseInt(id, 10) : id;

      // Check if it's a valid number and a positive integer
      if (
        typeof numId !== "number" ||
        isNaN(numId) ||
        !Number.isInteger(numId) ||
        numId <= 0
      ) {
        throw new Error(`Invalid ID: ${id}. All IDs must be positive integers`);
      }
    }

    return await this.repository.updateStatus(ids, status);
  }
}
